var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ui-modal',{ref:"modal",staticClass:"log-message-modal",attrs:{"dismiss-on":"close-button esc","size":"medium","title":"Log Conversation"}},[_c('log-message-pane',{ref:"messagePane",attrs:{"default-message-box":_vm.defaultMessageBox},on:{"saved":function($event){return _vm.$refs.modal.close()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }